import { render, staticRenderFns } from "./question-pupup.vue?vue&type=template&id=0b9f98f9&scoped=true"
import script from "./question-pupup.vue?vue&type=script&lang=js"
export * from "./question-pupup.vue?vue&type=script&lang=js"
import style0 from "./question-pupup.vue?vue&type=style&index=0&id=0b9f98f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f98f9",
  null
  
)

export default component.exports